/* =========================================================================
   Artis — theme behaviour
   Cart drawer, variant selection, PDP gallery, facets, press carousel.
   ========================================================================= */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ------------------------------------------------------------ cart drawer */
  var drawer = $('#CartDrawer');
  var drawerBg = $('#CartDrawerBg');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false; drawerBg.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('on'); drawerBg.classList.add('on'); });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('on'); drawerBg.classList.remove('on');
    setTimeout(function () { drawer.hidden = true; drawerBg.hidden = true; }, 250);
  }

  function renderCart(cart) {
    var count = $('#CartCount');
    if (count) { count.textContent = cart.item_count; count.setAttribute('data-count', cart.item_count); }

    var items = $('#CartDrawerItems');
    if (!items) return;

    if (!cart.items.length) {
      items.innerHTML = '<p class="cart-empty">Your bag is empty.</p>';
    } else {
      items.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">' : '';
        return '<div class="line">' +
          '<div class="art">' + img + '</div>' +
          '<div>' +
            '<a class="nm" href="' + item.url + '">' + item.product_title + '</a>' +
            '<div class="sub">' + (item.variant_title ? item.variant_title + ' · ' : '') + 'Qty ' + item.quantity + '</div>' +
            '<button class="rm" type="button" data-line="' + (cart.items.indexOf(item) + 1) + '">Remove</button>' +
          '</div>' +
          '<div class="line__price">' + money(item.final_line_price) + '</div>' +
        '</div>';
      }).join('');
    }

    var total = $('#CartDrawerTotal');
    if (total) total.textContent = money(cart.total_price);

    var ship = $('#CartDrawerShip');
    var threshold = (window.themeStrings && window.themeStrings.freeShipThreshold) || 0;
    if (ship) {
      ship.textContent = (cart.total_price >= threshold || cart.total_price === 0)
        ? 'Free standard shipping applied'
        : money(threshold - cart.total_price) + ' away from free standard shipping';
    }

    $$('#CartDrawerItems [data-line]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.getAttribute('data-line'), 0);
      });
    });
  }

  function fetchCart() {
    return fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeLine(line, quantity) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(form) {
    var data = new FormData(form);
    var button = form.querySelector('[name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  var cartToggle = $('#CartToggle');
  if (cartToggle) cartToggle.addEventListener('click', function () { fetchCart().then(openDrawer); });
  var cartClose = $('#CartDrawerClose');
  if (cartClose) cartClose.addEventListener('click', closeDrawer);
  if (drawerBg) drawerBg.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* -------------------------------------------------------- quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty'), 10);
    input.value = Math.max(parseInt(input.min || 1, 10), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------- variant picker */
  var variantSelects = $('variant-selects');
  if (variantSelects) {
    var json = variantSelects.querySelector('[data-variant-json]');
    var variants = json ? JSON.parse(json.textContent) : [];

    variantSelects.addEventListener('change', function () {
      var chosen = $$('.option-input:checked', variantSelects).map(function (i) { return i.value; });

      var match = variants.find(function (v) {
        return chosen.every(function (value, index) { return v.options[index] === value; });
      });

      $$('[data-selected-value]', variantSelects).forEach(function (el, i) {
        if (chosen[i]) el.textContent = chosen[i];
      });

      if (!match) return;

      var idInput = $('#ProductVariantId');
      if (idInput) idInput.value = match.id;

      var price = $('#ProductPrice');
      if (price) {
        price.innerHTML = '<div class="price">' + money(match.price) +
          (match.compare_at_price && match.compare_at_price > match.price
            ? '<span class="was">' + money(match.compare_at_price) + '</span>' : '') + '</div>';
      }

      var add = $('#AddToCart');
      if (add) {
        add.disabled = !match.available;
        add.textContent = match.available
          ? (window.themeStrings.addToBag || 'Add to bag')
          : (window.themeStrings.soldOut || 'Sold out');
      }

      if (match.featured_media) {
        var hero = $('#ProductHeroImage');
        if (hero && match.featured_media.preview_image) {
          hero.src = match.featured_media.preview_image.src;
          hero.srcset = '';
        }
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    });
  }

  /* ------------------------------------------------------------ PDP gallery */
  $$('.thumb[data-media-id]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      $$('.thumb[data-media-id]').forEach(function (t) { t.classList.remove('on'); });
      thumb.classList.add('on');
      var img = thumb.querySelector('img');
      var hero = $('#ProductHeroImage');
      if (img && hero) {
        hero.src = img.src.replace(/_\d+x\./, '_1200x.');
        hero.srcset = '';
        hero.alt = img.alt;
      }
    });
  });


  /* ---------------------------------------------------------------- facets */
  var facetForm = $('#FacetForm');
  if (facetForm) {
    facetForm.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(facetForm)).toString();
      window.location.search = params;
    });
    $$('.facet__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.parentElement;
        facet.classList.toggle('closed');
        var open = !facet.classList.contains('closed');
        btn.setAttribute('aria-expanded', open);
        var chev = btn.querySelector('span');
        if (chev) chev.textContent = open ? '–' : '+';
      });
    });
  }

  /* --------------------------------------------------------- press carousel */
  $$('press-carousel').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var slides = $$('.pc-slide', root);
    if (!slides.length) return;

    var dots = root.querySelector('[data-dots]');
    var counter = root.querySelector('[data-counter]');
    var play = root.querySelector('[data-play]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 7) * 1000;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduced;

    var i = 0, timer = null, paused = !autoplay;

    dots.innerHTML = slides.map(function (s, k) {
      return '<button type="button" class="pc-dot' + (k ? '' : ' on') + '" data-go="' + k + '" aria-label="Go to slide ' + (k + 1) + '"></button>';
    }).join('');
    var dotEls = $$('.pc-dot', dots);

    function go(k) {
      i = (k + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dotEls.forEach(function (d, x) { d.classList.toggle('on', x === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      slides.forEach(function (s, x) { s.setAttribute('aria-hidden', x !== i); });
    }
    function disarm() { clearInterval(timer); timer = null; }
    function arm() { disarm(); if (!paused) timer = setInterval(function () { go(i + 1); }, interval); }
    function sync() {
      if (!play) return;
      play.innerHTML = paused ? '&#9654;' : '&#9646;&#9646;';
      play.setAttribute('aria-label', paused ? 'Play' : 'Pause');
    }

    root.querySelector('[data-next]').addEventListener('click', function () { go(i + 1); arm(); });
    root.querySelector('[data-prev]').addEventListener('click', function () { go(i - 1); arm(); });
    dotEls.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-go'), 10)); arm(); });
    });
    if (play) play.addEventListener('click', function () { paused = !paused; sync(); arm(); });

    root.addEventListener('mouseenter', disarm);
    root.addEventListener('mouseleave', arm);
    root.addEventListener('focusin', disarm);
    root.addEventListener('focusout', arm);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(i + 1); paused = true; sync(); disarm(); }
      if (e.key === 'ArrowLeft') { go(i - 1); paused = true; sync(); disarm(); }
    });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; disarm(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
      x0 = null; arm();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { entry.isIntersecting ? arm() : disarm(); });
      }, { threshold: 0.25 }).observe(root);
    }

    go(0); sync(); arm();
  });

  /* ------------------------------------------------------ predictive search */
  var searchInput = $('#HeaderSearch');
  var results = $('#PredictiveResults');
  if (searchInput && results) {
    var t;
    searchInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = searchInput.value.trim();
      if (q.length < 2) { results.hidden = true; return; }
      t = setTimeout(function () {
        fetch(window.routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8&section_id=predictive-search')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            results.innerHTML = products.length
              ? products.map(function (p) {
                  return '<a href="' + p.url + '"><span>' + p.title + '</span>' +
                         '<span class="p">' + (p.price ? money(p.price) : '') + '</span></a>';
                }).join('')
              : '<div class="search-results__empty">No results.</div>';
            results.hidden = false;
          })
          .catch(function () { results.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.search')) results.hidden = true;
    });
  }

  /* ------------------------------------------------------ search toggle */
  var searchToggle = $('#SearchToggle');
  var searchPanel = $('#SearchPanel');
  if (searchToggle && searchPanel) {
    var openSearch = function (on) {
      searchPanel.hidden = !on;
      searchToggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on && searchInput) searchInput.focus();
      if (!on && results) results.hidden = true;
    };
    searchToggle.addEventListener('click', function () {
      openSearch(searchPanel.hidden);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hidden) openSearch(false);
    });
    document.addEventListener('click', function (e) {
      if (searchPanel.hidden) return;
      if (e.target.closest('#SearchPanel') || e.target.closest('#SearchToggle')) return;
      openSearch(false);
    });
  }
})();


/* mobile carousel arrows */
(function(){
  var SEL = '.section--bleed .catgrid--overlay, .section--bleed .catgrid--stack, .steps';
  function step(rail){
    var card = rail.firstElementChild;
    if(!card) return rail.clientWidth * 0.8;
    var cs = getComputedStyle(rail);
    var gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function sync(rail, nav){
    var max = rail.scrollWidth - rail.clientWidth - 2;
    nav.prev.disabled = rail.scrollLeft <= 2;
    nav.next.disabled = rail.scrollLeft >= max;
    var card = rail.firstElementChild;
    var art = card && (card.querySelector('.catcard__art, img, svg'));
    var h = art ? art.getBoundingClientRect().height : (card ? card.getBoundingClientRect().height : 0);
    if(!h) h = rail.getBoundingClientRect().height;
    nav.wrap.style.setProperty('--arrow-top', Math.round(h / 2) + 'px');
  }
  function build(rail){
    if(rail.__railnav) return rail.__railnav;
    var wrap = document.createElement('div');
    wrap.className = 'railwrap';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);
    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'railnav__b railnav__b--prev';
    next.className = 'railnav__b railnav__b--next';
    prev.setAttribute('aria-label','Previous');
    next.setAttribute('aria-label','Next');
    prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5 8 12l7 7"/></svg>';
    next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
    wrap.appendChild(prev); wrap.appendChild(next);
    prev.addEventListener('click', function(){ rail.scrollBy({left: -step(rail), behavior:'smooth'}); });
    next.addEventListener('click', function(){ rail.scrollBy({left: step(rail), behavior:'smooth'}); });
    var obj = {wrap:wrap, prev:prev, next:next};
    rail.__railnav = obj;
    rail.addEventListener('scroll', function(){ sync(rail, obj); }, {passive:true});
    return obj;
  }
  function refresh(root){
    (root || document).querySelectorAll(SEL).forEach(function(rail){
      var scrollable = rail.scrollWidth > rail.clientWidth + 8;
      if(!scrollable){ if(rail.__railnav) rail.__railnav.wrap.classList.remove('has-nav'); return; }
      var nav = build(rail);
      nav.wrap.classList.add('has-nav');
      sync(rail, nav);
    });
  }
  function boot(){ refresh(document); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  var t;
  window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(boot, 180); });
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', function(e){ refresh(e.target); });
})();
;(function(){var w=document.querySelector('.promo .wrap');if(!w)return;var a=w.textContent.split('·');if(a.length<2)return;w.textContent='';a.forEach(function(s,i){var e=document.createElement('span');e.className=i?'pm':'pm on';e.textContent=s.trim();w.appendChild(e)});var m=w.children,i=0;setInterval(function(){m[i].classList.remove('on');i=(i+1)%m.length;m[i].classList.add('on')},5000)})();